// extracted by mini-css-extract-plugin
export default {"floating-remove-button":"FloatingRemoveButton_floating-remove-button__F3QXT"};